module.exports = __webpack_public_path__ + "media/images/emblems/Thayngen_Wappen-2e0a5040a11c92563cd361df983d738b.svg";